import type { ChipProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

//
import { CloseIcon } from './CustomIcons';

// ----------------------------------------------------------------------

const COLORS = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
] as const;

// NEW VARIANT
declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    soft: true;
  }
}

const Chip = (theme: Theme) => {
  const isLight = theme.palette.mode === 'light';

  const rootStyle = (ownerState: ChipProps) => {
    const defaultColor = ownerState.color === 'default';

    const filledVariant = ownerState.variant === 'filled';

    const outlinedVariant = ownerState.variant === 'outlined';

    const softVariant = ownerState.variant === 'soft';

    const defaultStyle = {
      ...(defaultColor && {
        '& .MuiChip-avatar': {
          backgroundColor: alpha(theme.palette.grey[500], 0.48),
          color: theme.palette.text[isLight ? 'secondary' : 'primary'],
        },
        // OUTLINED
        ...(outlinedVariant && {
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.32)}`,
        }),
        // SOFT
        ...(softVariant && {
          '&:hover': {
            backgroundColor: alpha(theme.palette.grey[500], 0.32),
          },
          backgroundColor: alpha(theme.palette.grey[500], 0.16),
          color: theme.palette.text.primary,
        }),
      }),
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        '& .MuiChip-avatar': {
          backgroundColor: theme.palette[color].dark,
          color: theme.palette[color].lighter,
        },
        // FILLED
        ...(filledVariant && {
          '& .MuiChip-deleteIcon': {
            '&:hover': {
              color: theme.palette[color].contrastText,
            },
            color: alpha(theme.palette[color].contrastText, 0.56),
          },
        }),
        // SOFT
        ...(softVariant && {
          '&:hover': {
            // backgroundColor: alpha(theme.palette[color].main, 0.32),
          },
          '& .MuiChip-deleteIcon': {
            '&:hover': {
              color: theme.palette[color].dark,
            },
            color: alpha(
              theme.palette[color][isLight ? 'dark' : 'light'],
              0.48
            ),
          },
          backgroundColor: alpha(theme.palette[color].main, 0.16),
          color: theme.palette[color][isLight ? 'dark' : 'light'],
        }),
      }),
    }));

    return [...colorStyle, defaultStyle];
  };

  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: ChipProps }) =>
          rootStyle(ownerState),
      },
    },
  };
};

export default Chip;
